import React, { useState } from 'react';
import './result-sample-table.css';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper, SvgIcon,Box, Typography} from '@mui/material';
import Modals from '../modal/modal';
import Buttons from '../button';
import GenericImput from '../../components/text-imput';
import CircularProgress from "@mui/material/CircularProgress";
import { useSamples } from '../../contexts/SamplesContext';
import { useAuth } from "../../contexts/AuthContext";

interface Sample {
    sampleId: number,
    identification: string,
    order: number,
    services: Services[]
}
interface Services {
    samplePackageId: number;
    serviceId: number;
    finalResult: number;
}
interface UpdatePayload {
  samplePackageId: number;
  sampleId: number;
  serviceId: number;
  oldResult: number;
  newResult: number;
  userName: string;
}
interface DataTableProps {
data: Sample[];
}

const DataTable: React.FC<DataTableProps> = ({ data }) => {
  const { updateSamples } = useSamples();
  const { user } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [editions, setEditions] = useState<Record<number, string>>({});

    const handleInputChange = (id: number, value: string) => {
      if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
        setEditions(prev => ({ ...prev, [id]: value }));
      }
    };
    const handleUpdateAll = () => {
      setLoading(true);
      const payload: UpdatePayload[] = data
        .filter(row => editions[row.sampleId] && editions[row.sampleId] !== "")
        .map(row => ({
            samplePackageId: row.services[0].samplePackageId, 
            sampleId: row.sampleId,
            serviceId: row.services[0].serviceId,                                
            oldResult: row.services[0].finalResult,         
            newResult: parseFloat(editions[row.sampleId].replace(',', '.')),
            userName: user?.user_name || "Não encontrado"
        }));

      if (payload.length > 0) {
        setError(null);
        try{
          updateSamples(payload);
        }catch (error: any) {
            let errorMessage = "Ocorreu um erro inesperado.";
            if (error.response) {
                errorMessage = error.response.data?.message || "Erro ao editar resultado das amostras.";
            } else if (error.message) {
                errorMessage = error.message;
            }
            setError(errorMessage);
        }
        setLoading(false);
        handleOpenModal();
      } else {
        setError("Nenhuma amostra para alterar. Digite os novos resultados.")
        setLoading(false);
      }
    };
  
    const handleOpenModal = () => {
      setIsModalOpen(true);
    };
  
    const handleCloseModal = () => {
      setIsModalOpen(false);
    };
  
  return (
    <>        
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'flex-end',  
        mb: 2, 
        marginTop: '-2%',
        width: '100%' 
      }}>
          <Box sx={{ maxWidth: '300px' }}>
            <Buttons 
              label="Alterar Amostras" 
              onClick={handleUpdateAll}
              backgroundColor="var(--primary-color)"
              isLoading={loading}
              disabled={loading}
              starticon={
                <SvgIcon>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 7V12.75C12 12.9142 11.9677 13.0767 11.9048 13.2284C11.842 13.38 11.75 13.5178 11.6339 13.6339C11.5178 13.75 11.38 13.842 11.2284 13.9048C11.0767 13.9677 10.9142 14 10.75 14H3.25C2.91848 14 2.60054 13.8683 2.36612 13.6339C2.1317 13.3995 2 13.0815 2 12.75V5.25C2 4.91848 2.1317 4.60054 2.36612 4.36612C2.60054 4.1317 2.91848 4 3.25 4H8.48375" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14.3731 1.66407C14.3274 1.6139 14.2721 1.5735 14.2104 1.54533C14.1486 1.51715 14.0819 1.50178 14.014 1.50015C13.9462 1.49851 13.8788 1.51064 13.8158 1.53581C13.7528 1.56098 13.6955 1.59866 13.6475 1.64657L13.2609 2.03126C13.2141 2.07814 13.1877 2.1417 13.1877 2.20798C13.1877 2.27425 13.2141 2.33782 13.2609 2.3847L13.6153 2.73845C13.6385 2.76178 13.6661 2.7803 13.6965 2.79294C13.7269 2.80558 13.7595 2.81208 13.7925 2.81208C13.8254 2.81208 13.858 2.80558 13.8884 2.79294C13.9188 2.7803 13.9464 2.76178 13.9697 2.73845L14.3465 2.36345C14.5372 2.17313 14.555 1.86313 14.3731 1.66407ZM12.4794 2.81251L6.8381 8.44376C6.8039 8.47782 6.77904 8.52012 6.76591 8.56657L6.50498 9.34376C6.49873 9.36485 6.49828 9.38723 6.5037 9.40855C6.50911 9.42987 6.52017 9.44933 6.53573 9.46488C6.55128 9.48044 6.57074 9.4915 6.59206 9.49692C6.61338 9.50233 6.63576 9.50188 6.65685 9.49563L7.43341 9.2347C7.47987 9.22157 7.52216 9.19671 7.55623 9.16251L13.1875 3.52063C13.2396 3.46798 13.2688 3.3969 13.2688 3.32282C13.2688 3.24875 13.2396 3.17767 13.1875 3.12501L12.8765 2.81251C12.8238 2.75994 12.7524 2.73041 12.6779 2.73041C12.6035 2.73041 12.5321 2.75994 12.4794 2.81251Z" fill="white"/>
                  </svg>
                </SvgIcon>
              }
              sx={{ borderRadius: '100px' }}
            />
          </Box>
          <Box>
            {error && (
                <Typography 
                  sx={{ 
                  color: '#d32f2f', 
                  fontSize: '0.75rem',
                  fontWeight: 500,
                  marginLeft: '10px',
                  mt: 0.8, 
                  textAlign: 'right', 
                  }}>
              {error}
              </Typography>)}
          </Box> 
      </Box>
      {loading ? (
        <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />
      ) : (
        <TableContainer component={Paper} >
          <Table>
            <TableHead className='import-table-head'>
              <TableRow>
                <TableCell className='import-table-columns'>PEDIDO</TableCell>
                <TableCell className='import-table-columns'>Nº DA AMOSTRA</TableCell>
                <TableCell className='import-table-columns'>PARÂMETRO</TableCell>
                <TableCell className='import-table-columns'>1º RESULTADO (ORIGINAL)</TableCell>
                <TableCell className='import-table-columns'>2º RESULTADO (NOVO)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {data.map((row, index) => (
              <TableRow key={row.sampleId} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' } }}>
                <TableCell className='import-table-data'>{row.order}</TableCell>
                <TableCell className='import-table-data'>{row.identification}</TableCell>
                <TableCell className='import-table-data'>NITROGÊNIO</TableCell>
                <TableCell className='import-table-data'>{row.services[0].finalResult}</TableCell>
                <TableCell className='import-table-data'>
                  <GenericImput 
                    id={`input-result-${index}`}
                    placeholder="Novo resultado"
                    value={editions[row.sampleId] || ""}
                    type="number"
                    onChange={(e) => handleInputChange(row.sampleId, e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault(); 
                            const nextInput = document.getElementById(`input-result-${index + 1}`);
                            if (nextInput) {
                                nextInput.focus();
                            }
                        }
                    }}
                    sx={{
                      width: '200px',
                      '& .MuiInputBase-root': {
                          backgroundColor: 'white',
                          height: '35px', 
                          borderRadius: '4px',
                        },
                    }} 
                  />
                </TableCell>
              </TableRow>
            ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Modals
        open={isModalOpen}
        title="Amostras editadas com sucesso!"
        type='success'
        starticon={
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_437_5154)">
          <path d="M22 34L28 40L42 26" stroke="#FF9D33" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z" stroke="#FF9D33" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
          <clipPath id="clip0_437_5154">
          <rect width="64" height="64" fill="white"/>
          </clipPath>
          </defs>
          </svg>
        }
        actions={
          <>
            
          </>
        }
        onClose={handleCloseModal}
      />
    </>   
  );
};

export default DataTable;
